import React from "react";
import { Card } from "antd";
import { Award, Sparkles } from "lucide-react";


const EmployeeScoreCard = ({overallResult}) => {

  const scaleMap = {
    "Does not meet expectations": "Needs Focus",
    "Needs improvement": "Developing",
    "Meets": "Meets",
    "Exceeds": "Exceeds",
  };

  const getStatusClass = (scale) =>
    (scaleMap[scale] || "")
      .toLowerCase()
      .replace(/\s+/g, "-");

  
  return (
    <div className="space-y-6">
      <Card className="flex flex-col gap-6 rounded-xl border-2 border-purple-200 gradient-purple-pink50 dark:bg-pink-700/10">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-12 h-12 rounded-2xl shadow-md bg-text gradient-pink">
                  <Award 
                    size={24}
                  />
              </div>
              <div className="flex items-start flex-col">
                <p className="text-[13px] muted-text mb-1">Overall Performance Rating</p>
                <span className={`text-[14px] px-2 py-1.5 status-indicator ${getStatusClass(overallResult)}`}>
                  {overallResult}
                </span>
              </div>
            </div>
            <div className="flex">
                <Sparkles
                  className="text-purple-400 dark:text-purple-300"
                  size={32}
                />
            </div>
          </div>
      </Card>
    </div>


);
};

export default EmployeeScoreCard;